if (!customElements.get('quiz-wrapper')) {
  customElements.define(
    'quiz-wrapper',
    class QuizWrapper extends HTMLElement {
      connectedCallback() {
        // Select the slider container and slides
        this.sliderContainer = this.querySelector('.quizSliderWrapper');
        this.sliderSlides = this.querySelectorAll('.swiper-slide');
        this.isSelecting = false; // Flag to prevent multiple rapid selections

        // Add event listeners to the container for delegation
        this.sliderContainer.addEventListener('change', this.handleOptionSelection.bind(this));
        this.sliderContainer.addEventListener('click', this.handleOptionSelection.bind(this));
        this.sliderContainer.addEventListener('touchend', this.handleTouchEnd.bind(this));

        // Initialize the slider
        this.initSlider();
      }

      initSlider() {
        this.slider = new Swiper(".quizSliderWrapper", {
          effect: "cards",
          grabCursor: false,
          allowTouchMove: false,       // Prevent manual swiping
          simulateTouch: false,        // Disable touch simulation for iOS compatibility
          touchRatio: 0,               // Ensure no touch interference
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
              const totalSlide = this.slides.length - 1;
              if (totalSlide === index) {
                return `<span class="${className}">${index + 1}</span><span class='slide-progress-wrapper'><span class='slide-progress'></span></span>`;
              } else {
                return `<span class="${className}">${index + 1}</span>`;
              }
            },
          },
          allowSlideNext: false,       // Locked until a selection is made
          on: {
            slideChange: function () {
              // Check if the current slide has a selected radio button
              const selectedValue = this.slides[this.activeIndex].querySelector('input:checked');
              console.log('Slide changed to:', this.activeIndex, 'Selected:', selectedValue);
              this.allowSlideNext = selectedValue !== null;
            },
          },
        });
      }

      handleTouchEnd(evt) {
        // Handle touchend for iOS to ensure selections are captured
        if (evt.target.type === 'radio' && !this.isSelecting) {
          this.isSelecting = true;
          setTimeout(() => { this.isSelecting = false; }, 300); // Debounce
          this.handleOptionSelection(evt);
        }
      }

      handleOptionSelection(evt) {
        if (evt.target.type === 'radio' && !this.isSelecting) {
          this.isSelecting = true;
          setTimeout(() => { this.isSelecting = false; }, 300); // Debounce
          console.log('Selection on slide:', this.slider.activeIndex, 'Option:', evt.target.value);
          const baseUrl = "https://4700bc.com/collections/all?";
const checkedInputs = document.querySelectorAll(".quiz-container input:checked");

const params = new URLSearchParams();

checkedInputs.forEach(input => {
  params.append("filter.p.tag", input.value);
});

params.append("sort_by", "best-selling");
params.append("grid", "default");
params.append("view", "quiz");

const finalUrl = baseUrl + params.toString();

fetch(finalUrl)
  .then(response => response.text())
  .then(html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const bodyContent = doc.body.innerHTML;
    const resultWrapper = document.querySelector(".quiz-result-wrapper");

    if (resultWrapper) {
      resultWrapper.innerHTML = bodyContent;
    } else {
      console.warn("Result wrapper not found");
    }
  })
  .catch(error => {
    console.error("Fetch error:", error);
    document.querySelector(".quiz-result-wrapper").innerHTML = "<p>Error loading results.</p>";
  });

          this.slider.allowSlideNext = true; // Unlock the slider
          this.slider.update(); // Force the slider to recognize the change
        }
      }
    }
  );
}